import PhotoForegroundUpdateModal, {
  PHOTO_FOREGROUND_UPDATE_MODAL,
} from './modal';

export { PHOTO_FOREGROUND_UPDATE_MODAL };

export default PhotoForegroundUpdateModal;
